import React from 'react';
import * as S from './sub-category-delete.styles';

export interface ISubCategoryDeleteProps {
    message?: string;
    onDelete?: () => void;
}
export interface ISubCategoryDeleteState {
    active: boolean;
}

export class SubCategoryDelete extends React.PureComponent<ISubCategoryDeleteProps, ISubCategoryDeleteState> {
    constructor(props: ISubCategoryDeleteProps) {
        super(props);
        this.state = {
            active: false,
        };
    }
    public render(): React.ReactElement {
        return (
            <S.SubCategoryDelete>
                {!this.state.active && (
                    <S.SubCategoryDefault>
                        <S.Button variant="outlined" onClick={this.handleClick}>
                            {this.props.message}
                        </S.Button>
                    </S.SubCategoryDefault>
                )}
                {this.state.active && (
                    <S.SubCategoryConfirm>
                        <S.Button variant="outlined" onClick={this.handleCancel}>
                            Cancel
                        </S.Button>
                        <S.ConfirmButton variant="primary" onClick={this.handleConfirm}>
                            Are you sure?
                        </S.ConfirmButton>
                    </S.SubCategoryConfirm>
                )}
                <S.Note>You will receive an email to confirm your decision.</S.Note>
            </S.SubCategoryDelete>
        );
    }
    private readonly handleConfirm = (): void => {
        if (this.props.onDelete) {
            this.props.onDelete();
        }
        this.setState({ active: false });
    };
    private readonly handleCancel = (): void => {
        this.setState({ active: false });
    };
    private readonly handleClick = (): void => {
        this.setState({ active: true });
    };
}
